import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { PageHeader } from '@/components/ui/PageHeader'
import { Suspense } from 'react'
import { PlatformBreadcrumbs } from '../PlatformBreadcrumbs'
import { RedisMenu } from '../RedisMenu'
import { ImagesGridV2, ImagesLoading } from './ImagesGridV2'

export function PlatformImagesPage() {
  return (
    <>
      <PageHeader className="pr-3" title={<PlatformBreadcrumbs title="Images" />}>
        <RedisMenu />
      </PageHeader>
      <TablePageContainer>
        <QueryErrorBoundary errorMessage="Failed to load images">
          <Suspense fallback={<ImagesLoading />}>
            <ImagesGridV2 />
          </Suspense>
        </QueryErrorBoundary>
      </TablePageContainer>
    </>
  )
}
